module.exports = __webpack_public_path__ + "810cf972347b009fbf4601fcc7e126c0.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/small/madlaina-kalunder.jpg
// module id = 471
// module chunks = 0